import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconCar10: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="car-10, truck"><path d="M4.5 17.25H1.75V4.75H12.75V6.75H18.75L22.25 12V17.25H19.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M12.75 7V16.5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/><path d="M9.75 17.25H14.25" stroke="currentColor" strokeWidth="1.5"/><circle cx="7" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/><circle cx="17" cy="16.75" r="2.5" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconCar10;
